import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/solid/image-fill.svg'
import _imports_1 from '@/assets/icons/solid/video-fill.svg'


const _hoisted_1 = { class: "link" }
const _hoisted_2 = { class: "truncate inline-block space-x-1 text-sm w-full" }
const _hoisted_3 = { class: "my-6" }
const _hoisted_4 = { class: "grid grid-cols-3 gap-6" }
const _hoisted_5 = { class: "col-span-3 lg:col-span-1" }
const _hoisted_6 = {
  key: 0,
  class: "w-96 h-75 rounded-md bg-gray-300 animate-pulse"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 2,
  class: "flex justify-center items-center object-cover w-96 h-75 rounded-md bg-gray-300"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "grayed-icon h-10 w-10",
  src: _imports_0,
  alt: "picture icon"
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "col-span-3 lg:col-span-1" }
const _hoisted_12 = {
  key: 0,
  class: "w-96 h-75 rounded-md bg-gray-300 animate-pulse"
}
const _hoisted_13 = {
  key: 1,
  controls: "",
  class: "object-cover w-96 h-75 rounded-md"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 2,
  class: "flex justify-center items-center object-cover w-96 h-75 rounded-md bg-gray-300"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  class: "grayed-icon h-10 w-10",
  src: _imports_1,
  alt: "video icon"
}, null, -1)
const _hoisted_17 = [
  _hoisted_16
]

import { // languages
		useI18n
	} from 'vue-i18n'

	import { // store
		localesStore
	} from '@/store/locales'

	import { 
		store as userStore
	} from '@/store/user'

	import { // vue
		inject,
		onMounted,
		ref, 
		computed
	} from 'vue'

	
	const __default__ = { name: 'InstructionDetails' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		openToTab: {
			type: Number,
			default: 0
		},
		instruction: {
			type: Object,
			default: () => {return {}}
		},
		showDetails: {
			type: Function, 
			default: () => {return }
		},
		role:{
			type: Object,
			default: () => {return {}}
		}
	},
  setup(__props) {

	const props = __props

	const _localesStore = localesStore()
	const _userStore = userStore()

	const {t} = useI18n()

	function isStaffLoggedIn() {
		if(_userStore.getContactType === 'Staff') {
			return props.role?.['job__JOBS_ROLES__liveJobID_gStaffID::_kf_contacts_id'] === _userStore.user.contactId ||
				props.role?.['job__JOBS_ROLES__instrumentalJobID_gStaffID::_kf_contacts_id'] === _userStore.user.contactId ||
				props.role?.['job__JOBS_ROLES__standardJobID_gStaffID::_kf_contacts_id'] === _userStore.user.contactId
		}
		else {
			return true
		}
	}

	onMounted(async () => {
		fetchInstructionMedia()
	})

	const filesLoading = ref(true)
	const fetchS3File: any = inject('fetchS3File')
	const signedUrlPhoto = ref('')
	const signedUrlVideo = ref('')

	async function fetchInstructionMedia() {
		try { // fetching instruction image and video from s3
			filesLoading.value = true			
			signedUrlPhoto.value = await fetchS3File(props.scene?.['job__job_scene__CONTACTS_SCENES__contactSceneID::s3JSONPicture'])
			signedUrlVideo.value = await fetchS3File(props.scene?.['job__job_scene__CONTACTS_SCENES__contactSceneID::s3JSONVideo'])
		}
		catch(e) {
			console.error(e)
		}
		finally {
			filesLoading.value = false
		}
	}

return (_ctx: any,_cache: any) => {
  const _component_ArrowLeftIcon = _resolveComponent("ArrowLeftIcon")!
  const _component_data_display = _resolveComponent("data-display")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.showDetails(__props.role, isStaffLoggedIn() ? 4 : 1))),
        class: "flex justify-start items-center cursor-pointer"
      }, [
        _createVNode(_component_ArrowLeftIcon, { class: "w-5 h-5" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_unref(t)("nav.returnToInstructions")), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_data_display, {
        label: _unref(_localesStore).getLabel('181'),
        value: __props.instruction?.['jobs_roles__instructions_join_jobs__INSTRUCTIONS_JOIN__instructionsJoinID::instructions_display_edit']
      }, null, 8, ["label", "value"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_data_display, {
          label: _unref(_localesStore).getLabel('293')
        }, {
          custom: _withCtx(() => [
            (filesLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6))
              : (signedUrlPhoto.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    class: "object-cover w-96 h-75 rounded-md",
                    src: signedUrlPhoto.value
                  }, null, 8, _hoisted_7))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_data_display, {
          label: _unref(_localesStore).getLabel('294')
        }, {
          custom: _withCtx(() => [
            (filesLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12))
              : (signedUrlVideo.value)
                ? (_openBlock(), _createElementBlock("video", _hoisted_13, [
                    _createElementVNode("source", {
                      type: "video/mp4",
                      src: signedUrlVideo.value
                    }, null, 8, _hoisted_14)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
          ]),
          _: 1
        }, 8, ["label"])
      ])
    ])
  ], 64))
}
}

})